import React, { useState } from 'react';
import { MenuIcon, XIcon, GlobeIcon, ChevronDownIcon } from 'lucide-react';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  return <nav className="sticky top-0 z-50 bg-white border-b border-gray-200 backdrop-blur-md" data-id="element-320">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-321">
        <div className="flex justify-between h-16 items-center" data-id="element-322">
          {/* Left side menu items */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-323">
            <a href="#features" className="text-gray-800 hover:text-[#E87B5C] transition-colors font-medium" data-id="element-324">
              Features
            </a>
            <a href="#how-it-works" className="text-gray-800 hover:text-[#E87B5C] transition-colors font-medium" data-id="element-325">
              How It Works
            </a>
            <a href="#faq" className="text-gray-800 hover:text-[#E87B5C] transition-colors font-medium" onClick={e => {
            e.preventDefault();
            setIsMenuOpen(false);
            const faqElement = document.getElementById('faq');
            if (faqElement) {
              faqElement.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }} data-id="element-326">
              FAQ
            </a>
          </div>
          {/* Language Selector - stays on the right */}
          <div className="relative ml-auto" data-id="element-327">
            <button onClick={() => setIsLangMenuOpen(!isLangMenuOpen)} className="flex items-center text-gray-600 hover:text-[#E87B5C] transition-colors focus:outline-none" aria-label="Select language" data-id="element-328">
              <GlobeIcon className="h-5 w-5 mr-1" data-id="element-329" />
              <span className="hidden sm:inline-block mr-1 font-medium" data-id="element-330">
                English
              </span>
              <ChevronDownIcon className="h-4 w-4" data-id="element-331" />
            </button>
            {/* Language dropdown menu */}
            {isLangMenuOpen && <div className="absolute right-0 mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50" data-id="element-332">
                <div className="py-1" role="menu" aria-orientation="vertical" aria-labelledby="language-menu" data-id="element-333">
                  <div className="px-4 py-2 text-sm text-[#E87B5C] bg-gray-100 font-medium" data-id="element-334">
                    English
                  </div>
                  <div className="px-4 py-3 text-sm text-gray-500 border-t border-gray-100" data-id="element-335">
                    Emigo in other languages coming soon!
                  </div>
                </div>
              </div>}
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-336">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-800 hover:text-[#E87B5C] focus:outline-none" data-id="element-337">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-338" /> : <MenuIcon className="h-6 w-6" data-id="element-339" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-b border-gray-200 shadow-lg" data-id="element-340">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-341">
            <a href="#features" className="block px-3 py-2 text-gray-800 hover:bg-gray-50 hover:text-[#E87B5C] rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-342">
              Features
            </a>
            <a href="#how-it-works" className="block px-3 py-2 text-gray-800 hover:bg-gray-50 hover:text-[#E87B5C] rounded-md font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-343">
              How It Works
            </a>
            <a href="#faq" className="block px-3 py-2 text-gray-800 hover:bg-gray-50 hover:text-[#E87B5C] rounded-md font-medium" onClick={e => {
          e.preventDefault();
          setIsMenuOpen(false);
          const faqElement = document.getElementById('faq');
          if (faqElement) {
            faqElement.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} data-id="element-344">
              FAQ
            </a>
          </div>
        </div>}
    </nav>;
};
export default Navbar;